class PrintCartButon extends HTMLElement {
  formatPrice(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  }
  
  constructor() {
    super();

    // Load html2pdf library
    this.loadHTML2PDF();

    // New dropdown functionality
    const printTrigger = this.querySelector('.print-trigger-btn');
    const printDropdown = this.querySelector('.print-dropdown');
    const printWrapper = this.querySelector('.print-options-wrapper');

    if (printTrigger && printDropdown) {
      printTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        printWrapper.classList.toggle('active');
        printDropdown.classList.toggle('show');
      });

      document.addEventListener('click', (e) => {
        if (!printWrapper.contains(e.target)) {
          printWrapper.classList.remove('active');
          printDropdown.classList.remove('show');
        }
      });
    }

    const printOptionBtns = this.querySelectorAll('.print-option-btn');
    printOptionBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const printType = btn.getAttribute('data-print-type');
        this.printCart(printType);
        
        printWrapper.classList.remove('active');
        printDropdown.classList.remove('show');
      });
    });

    // Original single print button
    this.printButton = this.querySelector('[print-cart-button]');
    this.printButton?.addEventListener('click', () => {
      this.printCart('dealer-po'); // Default to dealer-po
    });
  }

  loadHTML2PDF() {
    if (!document.querySelector('#html2pdf-script')) {
      const script = document.createElement('script');
      script.id = 'html2pdf-script';
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js';
      document.head.appendChild(script);
    }
  }

  debugCartData() {
    // Check if cart data from Liquid is available
    const cartDataElement = document.querySelector('#cart-data-formatted');
    if (cartDataElement) {
      const cartDataAttr = cartDataElement.getAttribute('cartData');
      if (cartDataAttr) {
        try {
          const parsedCartData = JSON.parse(cartDataAttr);
          if (parsedCartData.cart && parsedCartData.cart.items) {
            parsedCartData.cart.items.forEach((item, index) => {
              if (item.components && item.components.length > 0) {
                item.components.forEach((comp, compIndex) => {
                });
              }
            });
          }
        } catch (e) {
        }
      }
    } else {
      console.log('Cart data element not found');
    }
    // Check DOM cart items
    const cartRows = document.querySelectorAll('tr.cart-item');
    cartRows.forEach((row, index) => {
      const title = row.querySelector('.cart-item__name .half-product-titles')?.textContent?.trim();
      const properties = row.querySelector('.properties-wrapper');
      const options = row.querySelectorAll('.product-option');
      
      console.log(`DOM Row ${index}: ${title}`);
      console.log(`  - Properties wrapper:`, properties ? 'Found' : 'Not found');
      console.log(`  - Product options:`, options.length);
      
      options.forEach((option, optIndex) => {
        console.log(`    Option ${optIndex}:`, option.textContent.trim());
      });
    });
  }

  async getShippingRates() {
    try {
      const response = await fetch('/cart/async_shipping_rates.json');
      const data = await response.json();
      
      if (data && data.shipping_rates && data.shipping_rates.length > 0) {
        // Return the first shipping rate
        const firstRate = data.shipping_rates[0];
        return {
          name: firstRate.name,
          price: parseFloat(firstRate.price),
          presentmentName: firstRate.presentment_name || firstRate.name,
          deliveryRange: firstRate.delivery_range || []
        };
      } else {
        console.warn("No shipping rates found", data);
        return null;
      }
    } catch (error) {
      console.error("Error fetching shipping rates:", error);
      return null;
    }
  }

  downsizeShopifyImageUrl(url, size = 200) {
    if (!url) return url;
    return url.replace(/(\.[a-zA-Z]+)(\?.*)?$/, `_${size}x$1$2`);
  }

  async printCart(printType = 'dealer-po') {
    this.debugCartData();
    if (!window.cartDataFormatted) {
      const cartDataElement = document.querySelector('#cart-data-formatted');
      if (cartDataElement) {
        const cartDataAttr = cartDataElement.getAttribute('cartData');
        if (cartDataAttr) {
          try {
            window.cartDataFormatted = JSON.parse(cartDataAttr);
            console.log('✓ Cart data parsed successfully:', window.cartDataFormatted);
          } catch (e) {
            console.error('✗ Failed to parse cart data:', e);
          }
        } else {
          console.error('✗ cartData attribute not found');
        }
      } else {
        console.error('✗ #cart-data-formatted element not found');
      }
    }
      // Wait for html2pdf to load
      while (!window.html2pdf) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      // Get cart items from DOM
      const cartItems = this.extractCartItemsData();
      if (!cartItems || cartItems.length === 0) return;
      const shippingRate = await this.getShippingRates();

      // Create the PDF content container
      const container = document.createElement('div');
      container.style.cssText = `
        width: 100%;
        min-height: 100vh;
        padding: 20px;
        margin: 0;
        font-family: "Helvetica", sans-serif;
        background: white;
      `;

      // Add header
      const headerContainer = this.createPDFHeader(printType);
      container.appendChild(headerContainer);

      // Add product table
      const productTable = this.createProductTable(cartItems, printType);
      container.appendChild(productTable);

      // Add footer with shipping and totals
      const footerContainer = this.createPDFFooter(printType, shippingRate, cartItems);
      container.appendChild(footerContainer);

      // Footer Spacer
      const spacer = document.createElement('div');
      spacer.style.cssText = 'height: 18mm; page-break-inside: avoid; break-inside: avoid;';
      container.appendChild(spacer);

      // Create temporary container and add to document with minimal visual impact
      const tempContainer = document.createElement('div');
      tempContainer.style.position = 'fixed';
      tempContainer.style.top = '0';
      tempContainer.style.left = '0';
      tempContainer.style.width = '100%';
      tempContainer.style.height = '100%';
      tempContainer.style.zIndex = '-1';
      tempContainer.style.opacity = '0';
      tempContainer.style.pointerEvents = 'none';
      tempContainer.appendChild(container);
      document.body.appendChild(tempContainer);

      // Force a reflow to ensure DOM is fully rendered
      void container.offsetHeight;
      
      // Detect Safari browser
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      
      // Preload all images and wait for them to load (critical for Safari)
      await this.preloadImages(container, isSafari);
      
      // Small delay to ensure first-time rendering is complete
      // Safari needs more time for first-time rendering
      await new Promise(resolve => setTimeout(resolve, isSafari ? 500 : 100));

      // Configure PDF options
      // Load web fonts
      if (document.fonts && document.fonts.ready) {
        await document.fonts.ready;
      }
      const scale = 1.5;

      const filename = printType === 'msrp' ? 'dmf-cart-msrp.pdf' : 'dmf-cart-dealer-po.pdf';
      const opt = {
        margin: [0.2, 1, 10, 1],
        filename,
        image: { type: 'jpeg', quality: 0.75 },
        html2canvas: { 
          scale,
          useCORS: true, 
          logging: false, 
          backgroundColor: '#ffffff', 
          scrollY: 0, 
          windowWidth: container.scrollWidth,
          allowTaint: true,
          imageTimeout: isSafari ? 20000 : 10000
        },
        jsPDF: { 
          unit: 'mm', 
          format: 'a4', 
          orientation: 'portrait', 
          compress: true
        }
      };

      try {
        // Show loading state
        const triggerBtn = this.querySelector('.print-trigger-btn') || this.printButton;
        if (triggerBtn) {
          triggerBtn.style.opacity = '0.5';
          triggerBtn.style.pointerEvents = 'none';
          
          const existingSvg = triggerBtn.querySelector('svg');
          const svgHtml = existingSvg ? existingSvg.outerHTML : '';
          
          if (triggerBtn.textContent) {
            triggerBtn.innerHTML = svgHtml + ' Print...';
          }
        }

        // Generate PDF
        await html2pdf()
          .set(opt)
          .from(container)
          .toPdf()
          .get('pdf')
          .then((pdf) => {
            const pageCount  = pdf.getNumberOfPages();
            const pageWidth  = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const date = new Date().toLocaleDateString('en-US', { 
              month: 'short', 
              day: 'numeric', 
              year: 'numeric' 
            });

            const leftText  = `${date}`;
            const rightText = 'dmfluxury.com';
            const margin    = 10;
            const baselineY = pageHeight - 8;

            pdf.setFont('helvetica', 'normal');
            pdf.setFontSize(8);

            for (let i = 1; i <= pageCount; i++) {
              pdf.setPage(i);
              pdf.text(leftText, margin, baselineY);

              const linkWidth = pdf.getTextWidth(rightText);
              const linkX     = pageWidth - margin - linkWidth;

              pdf.setFont('helvetica', 'bold');
              pdf.text(rightText, linkX, baselineY);
              pdf.setFont('helvetica', 'normal');
              pdf.link(linkX, baselineY - 3, linkWidth, 4, { url: 'https://dmfluxury.com' });
            }
          })
          .save();

      } catch (error) {
        console.error('Error generating PDF:', error);
        alert('There was an error generating the PDF. Please try again.');
      } finally {
        document.body.removeChild(tempContainer);
        
        const triggerBtn = this.querySelector('.print-trigger-btn') || this.printButton;
        if (triggerBtn) {
          triggerBtn.style.opacity = '1';
          triggerBtn.style.pointerEvents = 'auto';
          
          const existingSvg = triggerBtn.querySelector('svg');
          const svgHtml = existingSvg ? existingSvg.outerHTML : '';
          
          if (triggerBtn.textContent && triggerBtn.textContent.includes('Print')) {
            triggerBtn.innerHTML = svgHtml + ' Print';
          }
        }
      }
  }

  extractCartItemsData() {
    const items = [];
    const cartRows = document.querySelectorAll('tr.cart-item');
    
    // First, debug the cart data
    console.log('=== CART DATA DEBUG ===');
    if (window.cartDataFormatted && window.cartDataFormatted.cart) {
      console.log('Cart data found:', window.cartDataFormatted.cart);
      console.log('Total items:', window.cartDataFormatted.cart.items?.length);
      
      window.cartDataFormatted.cart.items?.forEach((item, idx) => {
        console.log(`Item ${idx}:`, item.product.title);
        console.log('  Metafields:', item.product.metafields);
      });
    } else {
      console.error('Cart data NOT found!');
    }
    console.log('=== END DEBUG ===\n');
    
    cartRows.forEach((row, index) => {
      const cartItemName = row.querySelector('.cart-item__name .half-product-titles');
      if (!cartItemName) return;
      
      const productTitle = cartItemName.textContent.trim();
      console.log(`\nProcessing row ${index}: ${productTitle}`);
      
      const imgElement = row.querySelector('.cart-item__image');
      const rawImageUrl = imgElement ? imgElement.src : '';
      const imageUrl = this.downsizeShopifyImageUrl(rawImageUrl, 200);
      
      const priceElement = row.querySelector('.product-option .print-hide, .product-option span:not(.printed-price)') || 
                          row.querySelector('.cart-item__final-price') ||
                          row.querySelector('[data-hulkapps-ci-price]');
      let price = '$0.00';
      if (priceElement) {
        price = priceElement.textContent.trim();
      }
      console.log(`  Original price: ${price}`);
      
      const quantityElement = row.querySelector('.quantity__input');
      const quantity = quantityElement ? parseInt(quantityElement.value) || 1 : 1;
      
      const fixtureInput = row.querySelector('input.fixture_input');
      const fixtureType = fixtureInput && fixtureInput.value.trim() ? fixtureInput.value.trim() : '';
      
      // Get MSRP metafield
      let msrpPrice = null;

      if (window.cartDataFormatted && window.cartDataFormatted.cart && window.cartDataFormatted.cart.items) {
        const cartItem = window.cartDataFormatted.cart.items[index];
        
        if (cartItem) {
          // Direct property check (from cart.js API)
          if (cartItem.msrp_price) {
            msrpPrice = parseFloat(cartItem.msrp_price);
            console.log(`  ✓ Found MSRP (direct): $${msrpPrice}`);
          }
          // Metafields array check (from liquid snippet)
          else if (cartItem.product && cartItem.product.metafields && Array.isArray(cartItem.product.metafields)) {
            const msrpMetafield = cartItem.product.metafields.find(m => 
              m.key === 'usd' && m.namespace === 'msrp'
            );
            
            if (msrpMetafield && msrpMetafield.value) {
              const msrpValue = parseFloat(msrpMetafield.value);
              // ✅ Check if valid and greater than 0
              if (!isNaN(msrpValue) && msrpValue > 0) {
                msrpPrice = msrpValue;
                console.log(`  ✓ Found MSRP (metafield): $${msrpPrice}`);
              }
            }
          }
        }
      }

      if (!msrpPrice) {
        console.warn(`  WARNING: No MSRP found for ${productTitle}`);
      }
      
      let detailedSpecs = [];
      
      const propertiesWrapper = row.querySelector('.properties-wrapper');
      if (propertiesWrapper) {
        const properties = propertiesWrapper.querySelectorAll('.property-item');
        
        let currentComponent = null;
        
        properties.forEach(prop => {
          const propText = prop.textContent.trim();
          let PropQuantity = '';
          if(prop.querySelector('span.prop_qty')){
           PropQuantity = prop.querySelector('span.prop_qty')?.textContent.trim();
          }
          const componentWithPriceMatch = propText.match(/^\(x\d+\)\s+([A-Z0-9\-]+)\s*-\s*\$[\d,]+\.?\d*\s*USD/);
          const componentWithoutPriceMatch = propText.match(/^\(x\d+\)\s+([A-Z0-9\-]+)\s*$/);
          
          if (componentWithPriceMatch || componentWithoutPriceMatch) {
            if (currentComponent) {
              detailedSpecs.push(currentComponent);
            }
            
            const skuMatch = componentWithPriceMatch || componentWithoutPriceMatch;
            currentComponent = {
              sku: skuMatch[1],
              qty:PropQuantity,
              details: []
            };
          } else if (currentComponent && propText && !propText.toLowerCase().includes('fixture type')) {
            let cleanDetail = propText;
            
            if (cleanDetail.includes(':')) {
              const parts = cleanDetail.split(':');
              const value = parts.slice(1).join(':').trim();
              
              if (value) {
                currentComponent.details.push(value);
              }
            }
          }
        });
        
        if (currentComponent) {
          detailedSpecs.push(currentComponent);
        }
      }
      
      if (detailedSpecs.length === 0 && window.cartDataFormatted && window.cartDataFormatted.cart && window.cartDataFormatted.cart.items) {
        const cartItem = window.cartDataFormatted.cart.items[index];
        if (cartItem && cartItem.components && cartItem.components.length > 0) {
          cartItem.components.forEach(component => {
            detailedSpecs.push({
              title: component.title,
              sku: component.sku,
              price: component.price ? `$${component.price.amount}` : '',
              variant_title: component.variant_title
            });
          });
        }
      }
      
      if (detailedSpecs.length === 0) {
        const productOptions = row.querySelectorAll('.product-option');
        let otherDetails = [];
        
        productOptions.forEach(option => {
          const optionText = option.textContent.trim();
          if (optionText && !optionText.includes('$') && optionText !== quantity.toString()) {
            if (optionText.includes(':')) {
              otherDetails.push(optionText);
            }
          }
        });
        
        if (otherDetails.length > 0) {
          detailedSpecs.push({
            title: productTitle,
            sku: this.extractSKUFromRow(row),
            details: otherDetails
          });
        }
      }
      
      if (detailedSpecs.length === 0) {
        const extractedSKU = this.extractSKUFromRow(row);
        
        detailedSpecs.push({
          title: productTitle,
          sku: extractedSKU,
          qty:'',
          details: []
        });
      }
      
      items.push({
        title: productTitle,
        image: imageUrl,
        price: price,
        msrpPrice: msrpPrice,
        quantity: quantity,
        fixtureType: fixtureType,
        bundleComponents: detailedSpecs
      });
      
      console.log(`  Final item data:`, {
        title: productTitle,
        price,
        msrpPrice,
        quantity
      });
    });
    
    console.log('\n=== FINAL ITEMS ===');
    console.log(items);
    
    return items;
  }

  extractSKUFromRow(row) {
    let sku = '';
    
    const skuElements = row.querySelectorAll('[data-variant-id], dt, .product-option, .property-item');
    
    skuElements.forEach((el) => {
      const text = el.textContent;
      
      if (text.includes('SKU:')) {
        sku = text.replace('SKU:', '').trim();
      } else if (text.match(/[A-Z]{2,}[\d\-]+/)) {
        const matches = text.match(/[A-Z]{2,}[\d\-]+/g);
        if (matches && matches.length > 0 && !sku) {
          sku = matches[0];
        }
      }
    });
    
    return sku;
  }

  // Helper function to preload all images in container
  async preloadImages(container, isSafari = false) {
    const images = container.querySelectorAll('img');
    if (images.length === 0) return;
    
    const imagePromises = Array.from(images).map((img) => {
      return new Promise((resolve, reject) => {
        // If image is already loaded, resolve immediately
        if (img.complete && img.naturalHeight !== 0) {
          resolve();
          return;
        }
        
        // Set up load and error handlers
        const onLoad = () => {
          img.removeEventListener('load', onLoad);
          img.removeEventListener('error', onError);
          resolve();
        };
        
        const onError = () => {
          img.removeEventListener('load', onLoad);
          img.removeEventListener('error', onError);
          // Even if image fails to load, resolve to continue PDF generation
          console.warn('Image failed to load:', img.src);
          resolve();
        };
        
        img.addEventListener('load', onLoad);
        img.addEventListener('error', onError);
        
        // Force image to load by setting src again if needed
        if (!img.src || img.src === window.location.href) {
          const src = img.getAttribute('src');
          if (src) {
            img.src = src;
          }
        }
        
        // Safari-specific: Force image reload to ensure it's cached
        if (isSafari && img.src) {
          const originalSrc = img.src;
          img.src = '';
          img.src = originalSrc;
        }
        
        // Timeout after 15 seconds (longer for Safari)
        setTimeout(() => {
          img.removeEventListener('load', onLoad);
          img.removeEventListener('error', onError);
          console.warn('Image load timeout:', img.src);
          resolve(); // Resolve anyway to continue
        }, isSafari ? 15000 : 10000);
      });
    });
    
    // Wait for all images to load
    await Promise.all(imagePromises);
    
    // Additional Safari-specific delay to ensure images are fully rendered
    if (isSafari) {
      await new Promise(resolve => setTimeout(resolve, 300));
    }
  }

  createProductTable(items, printType) {
    const table = document.createElement('div');
    table.style.cssText = `
      margin: 20px 0 0px;
      width: 100%;
      padding: 0px;
    `;
    
    const headerRow = document.createElement('div');
    headerRow.style.cssText = `
      display: flex;
      margin-bottom: 0px;
      font-weight: bold;
      font-size: 10px;
      line-height: 10px;
      color: #000000;
      padding-bottom: 6px;
      border-bottom: 0.5px solid #000000;
    `;
    
    headerRow.innerHTML = `
      <div style="text-align: left; border: none; padding: 10px 0px 0px; font-weight: bold; font-size: 12px; line-height: 10px; width: 60%;">Product</div>
      <div style="text-align: left; border: none; padding: 10px 5px 0px; font-weight: bold; font-size: 12px; line-height: 10px; width: 15%;">Unit Price</div>
      <div style="text-align: left; border: none; padding: 10px 5px 0px; font-weight: bold; font-size: 12px; line-height: 10px; width: 10%;">QTY</div>
      <div style="text-align: left; border: none; padding: 10px 5px 0px; font-weight: bold; font-size: 12px; line-height: 10px; width: 15%;">${printType === 'msrp' ? 'MSRP Price' : 'Dealer Price'}</div>
    `;
    
    table.appendChild(headerRow);
    
    items.forEach((item, index) => {
      // Create wrapper to ensure page-break works reliably
      const rowWrapper = document.createElement('div');
      rowWrapper.style.cssText = `
        page-break-inside: avoid !important;
        break-inside: avoid !important;
        page-break-after: avoid;
        break-after: avoid;
        page-break-before: auto;
        break-before: auto;
        overflow: hidden;
        display: block;
        width: 100%;
      `;
      
      const row = document.createElement('div');
      row.style.cssText = `
        display: flex;
        align-items: flex-start;
        padding: 10px 0px;
        page-break-inside: avoid !important;
        break-inside: avoid !important;
        color: #000000;
        border-bottom: 0.5px solid #000000;
        font-family: "Helvetica", sans-serif;
        width: 100%;
        box-sizing: border-box;
      `;
      
      // **UPDATED: Use MSRP metafield price**
      const unitPriceNum = parseFloat(item.price.replace(/[$,]/g, ''));
      let finalUnitPrice;

      if (printType === 'msrp') {
        if (item.msrpPrice && item.msrpPrice > 0) {
          // ✅ Valid MSRP metafield exists - use it
          finalUnitPrice = item.msrpPrice;
        } else {
          // ✅ No MSRP or invalid MSRP - double the original price
          finalUnitPrice = unitPriceNum * 2;
        }
      } else {
        // Dealer PO - use original price
        finalUnitPrice = unitPriceNum;
      }
      
      const totalPrice = finalUnitPrice * item.quantity;
      
      let componentDetails = '';

      if (item.bundleComponents && item.bundleComponents.length > 0) {
        item.bundleComponents.forEach((component, componentIndex) => {
          if (componentIndex > 0) {
            componentDetails += `<div style="margin: 10px 0 0; padding-top: 10px; border-top: 0.5px solid #CCCCCC;"></div>`;
          }
          
          componentDetails += `<div style="margin: 6px 0; padding: 0;">`;
          
          if (component.title && component.title !== item.title) {
            componentDetails += `<div style="font-weight: 400; font-size: 12px; line-height: 14px; margin-bottom: 3px; max-width: 238px;">${component.title}</div>`;
          }
          
          if (component.sku) {
            componentDetails += `<div style="font-weight: 400; font-size: 12px; line-height: 14px; color: #000000; margin-bottom: 3px;">SKU: ${component.sku} ${component.qty}</div>`;
          }
          
          if (component.details && component.details.length > 0) {
            const detailsText = component.details.join(', ');
            componentDetails += `<div style="font-weight: 400; font-size: 12px; line-height: 14px; color: #000000; max-width: 238px; margin-bottom: 10px;">Details: ${detailsText}</div>`;
          }
          
          componentDetails += `</div>`;
        });
      }
      
      row.innerHTML = `
        <div style="padding: 10px 0px; vertical-align: top; width: 60%; border: none;">
          <div style="display: flex;">
            <img src="${item.image}" alt="${item.title}" style="width: 56px; height: 76px; margin-right: 13px; object-fit: cover; border-radius: 0px;">
            <div style="width: calc(100% - 49px);">
              <div style="font-weight: bold; font-size: 12px; line-height: 14px; margin-bottom: 2px; max-width: 238px;">
                ${item.title}
              </div>
              <div style="font-size: 12px; color: #000000; font-weight: 400; line-height: 14px;">
                ${componentDetails}
                ${item.fixtureType ? `Fixture Type: ${item.fixtureType}` : ''}
              </div>
            </div>
          </div>
        </div>
        <div style="padding: 10px 5px; text-align: left; font-weight: 400; border: none; font-size: 12px; line-height: 10px; width: 15%;">
          ${this.formatPrice(finalUnitPrice)}
        </div>
        <div style="padding: 10px 5px; text-align: left; font-size: 12px; line-height: 10px; font-weight: 400; border: none; width: 10%;">
          ${item.quantity}
        </div>
        <div style="padding: 10px 5px; text-align: left; font-weight: bold; border: none; font-size: 12px; line-height: 10px; width: 15%;">
          ${this.formatPrice(totalPrice)}
        </div>
      `;
      
      rowWrapper.appendChild(row);
      table.appendChild(rowWrapper);
    });
    
    return table;
  }

  createPDFHeader(printType) {
    const title = printType === 'msrp' ? 'MSRP' : 'Confidential Pricing';

    const headerContainer = document.createElement('div');
    headerContainer.style.cssText = `
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      padding-bottom: 5px;
      align-items: flex-start;
      font-family: "Helvetica", sans-serif;
    `;
    
    headerContainer.innerHTML = `
      <div style="width: 33.33%"><h1 style="margin: 0 0 5px 0; font-size: 30px; font-weight: 400; font-family: 'Austin'; font-style: italic; letter-spacing: 0.65px; color: #000000">${title}</h1></div>
      <div style="width: 33.33%; text-align: center;">&nbsp;</div>
      <div style="text-align: right; width: 33.33%">
        <svg width="62" height="24" viewBox="0 0 90 35" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.4789 11.8786H17.3842C15.7263 9.65432 13.4053 8.51852 10.3737 8.51852C3.41053 8.51852 0 14.5761 0 20.965C0 27.8745 3.26842 34.5 10.9895 34.5C13.8316 34.5 16.2 33.2695 17.7632 30.9506H17.8579V33.7901H25.5316V0H17.4789V11.8786ZM12.9789 28.3477C9.28421 28.3477 8.05263 24.609 8.05263 21.249C8.05263 18.1255 9.28421 14.6708 12.9789 14.6708C16.4842 14.6708 17.7632 17.9362 17.7632 21.4856C17.7632 24.609 16.9105 28.3477 12.9789 28.3477Z" fill="#141414"/>
          <path d="M60.4895 8.51852C57.1737 8.51852 54.7579 9.89094 52.8158 12.4938C51.4895 9.51234 48.7421 8.51852 45.6632 8.51852C42.5842 8.51852 40.0737 10.1276 38.6053 12.5885H38.5105V9.22839H30.6947V33.7901H38.7474V21.8169C38.7474 16.8004 39.9789 15.144 42.8684 15.144C45.0474 15.144 45.9 16.9424 45.9 19.8292V33.7901H53.9526V21.7695C53.9526 17.7942 54.2842 15.144 57.7421 15.144C59.8263 15.144 61.1053 16.7058 61.1053 19.356V33.7901H69.1579V19.1193C69.1579 14.4342 68.3053 8.51852 60.4895 8.51852Z" fill="#141414"/>
          <path d="M87.8211 5.67901C88.5316 5.67901 89.2421 5.72634 90 5.82099V0.141975C88.7211 0.0946502 87.3947 0 86.1158 0C79.2474 0 76.7842 2.17695 76.7842 9.22839H72.9V14.4342H76.7842V33.7901H84.8368V14.4342H89.6684V9.22839H84.8368V8.13992C84.8368 5.91564 85.9737 5.67901 87.8211 5.67901Z" fill="#141414"/>
        </svg>
      </div>
    `;

    return headerContainer;
  }

  createPDFFooter(printType, shippingRate, cartItems) {
    // **UPDATED: Calculate subtotal using MSRP metafield**
    let formattedTotal = 0;

      if (printType === 'msrp') {
        cartItems.forEach(item => {
          const unitPriceNum = parseFloat(item.price.replace(/[$,]/g, ''));
          let priceToUse;
          
          if (item.msrpPrice && item.msrpPrice > 0) {
            priceToUse = item.msrpPrice;
          } else {
            priceToUse = unitPriceNum * 2;
          }
          
          formattedTotal += priceToUse * item.quantity;
        });
      } else {
      if (window.shippingData && window.shippingData.cart_total) {
        formattedTotal = parseFloat(window.shippingData.cart_total) || 0;
      } else {
        const cartTotalElement = document.querySelector('[data-hulkapps-cart-total], .totals__total-value, [subtotal-value]');
        const cartTotalText = cartTotalElement ? cartTotalElement.textContent.trim() : '$0.00';
        const cartTotal = cartTotalText.replace(/[$,\s]/g, '');
        formattedTotal = parseFloat(cartTotal) || 0;
      }
    }
    
    const displayTotal = this.formatPrice(formattedTotal);
    
    let shippingAddress = 'Your Company Name<br>1234 W Main Street<br>Anytown, USA 55512';
    let shippingCost = 'Calculated at Checkout';
    let totalDisplay = 'Calculated at Checkout';

    if (window.shippingData && window.shippingData.success) {
      if (window.shippingData.company_name && window.shippingData.company_address) {
        const company = window.shippingData.company_name;
        const addr = window.shippingData.company_address;
        
        shippingAddress = `
          ${company}<br>
          ${addr.address1 ? `${addr.address1}<br>` : ''}
          ${addr.address2 ? `${addr.address2}<br>` : ''}
          ${addr.city && addr.provinceCode && addr.zip ? 
            `${addr.city}, ${addr.provinceCode} ${addr.zip}` : ''}
        `;
      }
      
      if (window.shippingData.shipping_rates && window.shippingData.shipping_rates.length > 0) {
        const firstRate = window.shippingData.shipping_rates[0];
        const shippingCostValue = firstRate.total_charge || 0;
        
        if (shippingCostValue === 0 || window.shippingData.free_shipping_applied) {
          shippingCost = 'FREE';
          totalDisplay = displayTotal;
        } else {
          shippingCost = this.formatPrice(shippingCostValue);
          totalDisplay = this.formatPrice(formattedTotal + shippingCostValue);
        }
      }
    } else if (shippingRate) {
      if (shippingRate.price === 0) {
        shippingCost = 'FREE';
        totalDisplay = `${displayTotal}`;
      } else {
        shippingCost = this.formatPrice(shippingRate.price);
        totalDisplay = this.formatPrice(formattedTotal + shippingRate.price);
      }
    }

    const footerContainer = document.createElement('div');
    
    footerContainer.style.cssText = `
      margin-top: 0px;
      padding: 12px 0px 0px;
      display: flex;
      color: #000000;
      justify-content: space-between;
      align-items: flex-start;
      font-family: "Helvetica", sans-serif;
      page-break-inside: avoid;
      break-inside: avoid; 
      font-size: 10px;
      line-height: 10px;
      font-weight: bold;
      margin-bottom: 30px;
    `;
    
    const pdfNote = window.themeSettings?.pdf_notes || 'Sales taxes are not included and will be calculated at the time of purchase. The address above is used to estimate shipping costs. If a different address is required, please contact a sales support team member for a custom quote.';

    footerContainer.innerHTML = `
      <div style="width: 100%; margin-right: 20px;">
        <h3 style="font-size: 12px; line-height: 10px; font-weight: bold; margin: 0 0 9px 0; color: #000000;">Shipping Address</h3>
        <div style="color: #000000; line-height: 14px; font-size: 12px; font-weight: 400;">
          ${shippingAddress}
        </div>
        <p style="font-size: 10px; color: #000000; margin: 9px 0 0 0; line-height: 14px; max-width: 248px; font-weight: 400; font-style: italic;">
          <strong>Note:</strong> ${pdfNote}
        </p>
      </div>

      <div style="flex: 0 0 294px; text-align: left;">
        <div style="padding: 0px;">
          
          <div style="display: flex; border-bottom: 0.5px solid #000000; padding-bottom: 8px;">
            <span style="color: #000000; font-weight: bold; font-size: 12px; line-height: 10px; width: 100px;">SubTotal</span>
            <span style="font-weight: bold; color: #000000; font-size: 12px; line-height: 10px; padding-left: 87px;">${displayTotal}</span>
          </div>
          
          <div style="display: flex; border-bottom: 0.5px solid #000000; padding: 8px 0px;">
            <span style="color: #000000; font-weight: bold; font-size: 12px; line-height: 10px; width: 100px;">Shipping</span>
            <span style="color: #000000; font-style: italic; font-size: 12px; line-height: 10px; padding-left: 87px;">${shippingCost}</span>
          </div>
          
          <div style="display: flex; font-weight: bold; border-bottom: 0.5px solid #000000; padding: 8px 0px;">
            <span style="color: #000000; font-weight: bold; font-size: 12px; line-height: 10px; width: 100px;">Total</span>
            <span style="color: #000000; font-style: italic; font-size: 12px; line-height: 10px; padding-left: 87px;">${totalDisplay}</span>
          </div>
          
        </div>
      </div>
    `;

    return footerContainer;
  }
}

customElements.define('print-cart-button', PrintCartButon);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      
      // First check what will remain after removing this item
      this.checkBeforeRemove();
    });
  }

  checkBeforeRemove() {
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    const removeIndex = parseInt(this.dataset.index);
    
    fetch('/cart.json')
      .then(response => response.json())
      .then(cart => {
        // Simulate removal - what items will remain?
        const remainingItems = cart.items.filter((item, index) => {
          return (index + 1) !== removeIndex; // Cart indices are 1-based
        });
        
        // Check if only TARIFF items will remain
        const onlyTariffWillRemain = remainingItems.length > 0 && 
                                    remainingItems.every(item => item.sku === 'TARIFF');
        
        if (onlyTariffWillRemain) {
          // Clear entire cart instead of removing individual item
          fetch('/cart/clear.js', { method: 'POST' })
            .then(() => window.location.reload());
        } else {
          // Normal removal
          cartItems.updateQuantity(removeIndex, 0);
        }
      })
      .catch(() => {
        // Fallback to normal removal if prediction fails
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        cartItems.updateQuantity(removeIndex, 0);
      });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  ignoreValidation(event){
    // somefields in the page does not require quantity validation
    const ignoreFieldsAttribute = ['edit-fixture-field']
    let ignoreValidation = false;

    for (let i = 0; i < ignoreFieldsAttribute.length; i++) {
      const attribute = ignoreFieldsAttribute[i];

      if(event.target.hasAttribute(attribute)){
        ignoreValidation = true;
        break;
      }
      
    }
    return ignoreValidation;
  }

  onChange(event) {
    const ignoreValidation = this.ignoreValidation(event)

    if(!ignoreValidation){
      this.validateQuantity(event);
    }
    
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset?.id,
        selector: '.js-contents',
      },
    ];
  }

  updateSubtotalPrice(subtotalPrice){
    const subtotal = document.querySelectorAll('[subtotal-value]');
    if(subtotal.length){
      for (let i = 0; i < subtotal.length; i++) {
        const subtotalElement = subtotal[i];
        const money = window.Shopify.formatMoney(subtotalPrice)
        subtotalElement.textContent = money;
      }
    }
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.updateSubtotalPrice(parsedState.items_subtotal_price / 100)
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
            if(elementToReplace){
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);
        

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch((err) => {
        console.error('inside updateQuantity', err)
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        window.checkStatus();
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html')?.querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    
    document.querySelector('form.cart__contents')?.classList.add('loading-element')

    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    
    document.querySelector('form.cart__contents')?.classList.remove('loading-element')

    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}